import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `colors`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Created Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `colors/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Update Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `colors/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "colors",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `colors/${args.id}`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
export default { list, create, update, remove, find };
